import { PublicClientApplication } from "@azure/msal-browser"
import { getPublicConfig } from "../config/config"
import { msalConfig } from "../config/msalConfig"

let instance: PublicClientApplication | null = null
let scopes: string[] | null = null

export function getMsalInstance(): {
  instance: PublicClientApplication
  scopes: string[]
} {
  if (!instance) {
    instance = new PublicClientApplication(msalConfig)
  }

  if (!scopes) {
    const config = getPublicConfig()
    scopes = config.auth.msalApiScope ? [config.auth.msalApiScope] : []
  }

  return { instance, scopes }
}

// Clean up on HMR (Hot Module Replacement) in development
// This prevents the "duplicate instance" warning during hot reloads
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    instance = null
    scopes = null
  })
}
